import { AppErrors } from './app.errors';

export class BadRequestError extends AppErrors {}

export class ForbiddenError extends AppErrors {}

